import React from 'react';
import ChefView from '../UI/ChefView';
import Carousel from "@ingka/carousel";

const SeventhSection = (props) => {

    return (
        <>

            {(props.item.category7[0] && props.item.category7[0].title) && <h3> {props.item.category7[0].title} </h3>}
            {(props.item.category7[0] && props.item.category7[0].description) && <p>{props.item.category7[0].description}</p>}

            {(props.item.category7[0] && props.item.category7[0].content) &&
                <div className="seventh-section">
                    <Carousel>
                    {props.item.category7[0].content.map((chef) => (
                        <ChefView
                            key={chef.id}
                            cardImage={chef.cardImage}
                            cardTitle={chef.cardTitle}
                            cardDescription={chef.cardDescription}
                        />
                    ))}
                    </Carousel>
                </div>}
        </>

    )
}

export default SeventhSection;